import { Link, matchPath, useLocation } from 'react-router-dom';

export interface TabItem {
  key: string;
  href: string;
  label: string;
}

/**
 * Sibling views of one page, each its own URL, so a reload or a shared link
 * opens the same tab. A tab is lit when its `href` is exactly the current
 * path; a page that wants one lit elsewhere links to it from there.
 */
export function Tabs({ items, label }: { items: TabItem[]; label: string }) {
  const { pathname } = useLocation();
  return (
    <nav className="tab-bar" aria-label={label}>
      {items.map((item) => {
        const active =
          matchPath({ path: item.href, end: true }, pathname) !== null;
        return (
          <Link
            key={item.key}
            to={item.href}
            className={active ? 'tab-link is-active' : 'tab-link'}
            aria-current={active ? 'page' : undefined}
          >
            {item.label}
          </Link>
        );
      })}
    </nav>
  );
}
